import { CommonStateEnum } from "./common";
import { Product } from "./product";
import { User } from "./user";

export interface FactoryInventory {
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator: User | null;
  updater: User | null;
  productId: string;
  count: number;
  product: Product;
};

export enum FactoryInventorySourceType {
  MANUAL = 1,
  PRODUCTION,
  PURCHASE,
  SALE,
  DISPOSE,
  REQUIREMENT,
  OTHER = 99
};

export interface AddFactoryInventoryItem {
  productId: string;
  count: number;
};

export interface AddFactoryInventory {
  sourceType: FactoryInventorySourceType;
  sourceId: string;
  desc: string;
  items: AddFactoryInventoryItem[];
};

export enum FactoryDirectionEnum {
  INBOUND = 1,
  OUTBOUND = 2
};

export enum FactoryOptEnum {
  BATCH_ADD = 1,
  ADJUST = 2,
  COUNT = 3,
};
export interface FactoryInventoryHistory {
  id: string;
  createdAt: number;
  createdBy: string;
  creator: User | null;
  batchId: string;
  batchNo: string;
  opType: FactoryOptEnum;
  sourceType: FactoryInventorySourceType;
  sourceId: string;
  productId: string;
  product: Product;
  direction: FactoryDirectionEnum;
  beforeCount: number;
  afterCount: number;
  changeCount: number;
};